import React from "react";

import styles from "components/user-documentation/styles/documentationModal.module.scss";

import { CATEGORIES, Category } from "../types";

interface TutorialSidebarProps {
  selectedCategory: Category;
  onCategoryChange: (category: Category) => void;
}

const TutorialSidebar = ({
  selectedCategory,
  onCategoryChange
}: TutorialSidebarProps) => {
  const handleCategoryClick = (category: Category) => {
    onCategoryChange(category);
  };

  return (
    <div data-testid="tutorial-sidebar" className={styles.tutorialSidebarContainer}>
      {CATEGORIES.map((category) => (
        <div
          key={category}
          className={`${styles.tutorialSidebarItem} ${
            selectedCategory === category ? styles.active : ""
          }`}
          onClick={() => handleCategoryClick(category)}
          data-testid={`category-item-${category.replace(/\s+/g, "-")}`}
          data-selected={selectedCategory === category}>
          {category}
        </div>
      ))}
    </div>
  );
};

export default TutorialSidebar;
